import { Checkbox, Form, Spin } from 'antd';
import { Grid, PageWrapper } from 'assests/styles/globalStyles';
import React, { useState } from 'react';
import { Address, ContactForm, DarkCheckboxGroup, DarkInput, DarkTextArea, LookingFor, SubmitButton } from './styles';

import emailjs from '@emailjs/browser';
import { notification } from 'antd';


const Contact: React.FC = () => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    const submitForm = (values: any) => {
        setIsLoading(true);
        // Send email using EmailJS
        emailjs.send(
            'service_gqn6n7a',
            'template_2f867nv',
            {
                from_name: values.name,
                from_email: values.email,
                telephone: values.phone,
                message: values.message + '\n\nThis message was sent from the contact form on ai labs.',
            },
            'user_oN8o4lj3ZEmi4tPAdjeGY'
        ).then(() => {
            // Success logic
            setIsLoading(false);
            notification.success({
                message: 'Message Sent',
                description: 'Thank you for contacting us! We will get back to you soon.',
            });
            // Optionally reset the form
            form.resetFields();

        }, (error) => {
            // Error logic
            setIsLoading(false);
            notification.error({
                message: 'Message Failed',
                description: 'There was an error sending your message. Please try again later.',
            });
            console.error('FAILED...', error);
        });
    };


    return (
        <PageWrapper>
            <LookingFor>
                <div>
                    <h5>Contact</h5>
                    <h1><span>Looking</span> for us?</h1>
                    <p>Reach out to us for your tech requirements!</p>
                </div>

                <Address>
                    <address>
                        <ul>
                            <li>Kakkanad, Cochin</li>
                            <li>India</li>
                            <li>
                                <a href="tel:+917994884447">(+91) 7994-884-447</a>
                            </li>
                        </ul>
                        <ul>
                            <li>Toronto, Ontario</li>
                            <li>Canada</li>
                            <li>
                                <a href="tel:+16478863404">+1 (647) 886-3404</a>
                            </li>
                        </ul>
                        <ul>
                            <li>Meydan Grandstand</li>
                            <li>Nad Al Sheba</li>
                            <li>Dubai, U.A.E.</li>
                        </ul>
                        <ul>
                            <li>
                                <a href="mailto:hello@lookingsoft.com">hello@lookingsoft.com</a>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a
                                    href="https://www.facebook.com/profile.php?id=100071120866379&mibextid=ZbWKwL"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Lookings Soft - Facebook"
                                >
                                    <svg viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.8152 14.0319c.3507-.0207.526-.196.526-.526L15.3104.5413c.0206-.3506-.1444-.5157-.495-.495L1.8506.0153c-.33 0-.5054.1754-.526.526V1.779c0 .33.1753.5054.526.526h9.592L.8914 12.856c-.2475.2476-.2475.4952 0 .7427l.8664.8663c.2475.2476.495.2476.7426 0l10.551-10.551v9.5919c.0207.1444.0826.2681.1857.3713s.2166.1547.3404.1547z" />
                                    </svg>
                                    <strong>facebook</strong>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/looking_soft/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Lookings Soft - Instagram"
                                >
                                    <svg viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.8152 14.0319c.3507-.0207.526-.196.526-.526L15.3104.5413c.0206-.3506-.1444-.5157-.495-.495L1.8506.0153c-.33 0-.5054.1754-.526.526V1.779c0 .33.1753.5054.526.526h9.592L.8914 12.856c-.2475.2476-.2475.4952 0 .7427l.8664.8663c.2475.2476.495.2476.7426 0l10.551-10.551v9.5919c.0207.1444.0826.2681.1857.3713s.2166.1547.3404.1547z" />
                                    </svg>
                                    <strong>instagram</strong>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/company/lookings/about/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Lookings Soft - LinkedIn"
                                >
                                    <svg viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.8152 14.0319c.3507-.0207.526-.196.526-.526L15.3104.5413c.0206-.3506-.1444-.5157-.495-.495L1.8506.0153c-.33 0-.5054.1754-.526.526V1.779c0 .33.1753.5054.526.526h9.592L.8914 12.856c-.2475.2476-.2475.4952 0 .7427l.8664.8663c.2475.2476.495.2476.7426 0l10.551-10.551v9.5919c.0207.1444.0826.2681.1857.3713s.2166.1547.3404.1547z" />
                                    </svg>
                                    <strong>linkedin</strong>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://twitter.com/LookingSoft"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Lookings Soft - Twitter"
                                >
                                    <svg viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.8152 14.0319c.3507-.0207.526-.196.526-.526L15.3104.5413c.0206-.3506-.1444-.5157-.495-.495L1.8506.0153c-.33 0-.5054.1754-.526.526V1.779c0 .33.1753.5054.526.526h9.592L.8914 12.856c-.2475.2476-.2475.4952 0 .7427l.8664.8663c.2475.2476.495.2476.7426 0l10.551-10.551v9.5919c.0207.1444.0826.2681.1857.3713s.2166.1547.3404.1547z" />
                                    </svg>
                                    <strong>twitter</strong>
                                </a>
                            </li>
                        </ul>
                    </address>
                </Address>
            </LookingFor>

            <LookingFor style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                <div>
                    <h1>Say <span>Hello</span></h1>
                </div>
            </LookingFor>

            <ContactForm>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={submitForm}
                    requiredMark={false}
                >

                    <Grid col={2} gap={20} >
                        <Form.Item
                        label="Name"
                        name="name"
                        rules={[{ required: true, message: 'Please enter your name' }]}
                        style={{ marginBottom: 25 }}
                    >
                        <DarkInput />
                    </Form.Item>

                    <Form.Item
                        label="Company Name"
                        name="company"
                        rules={[{ required: true, message: 'Please enter your company name' }]}
                        style={{ marginBottom: 25 }}
                    >
                        <DarkInput />
                    </Form.Item>
                    </Grid>

        <Grid col={2} gap={20} >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter your email' },
                            { type: 'email', message: 'Please enter a valid email' },
                        ]}
                        style={{ marginBottom: 25 }}
                    >
                        <DarkInput />
                    </Form.Item>


                    <Form.Item
                        label="Telephone number"
                        name="phone"
                        rules={[{ required: true, message: 'Please enter your telephone number' }]}
                        style={{ marginBottom: 25 }}
                    >
                        <DarkInput />
                    </Form.Item>
                    </Grid>

                        <Form.Item
                            label="Type of project"
                            name="projectType"
                            style={{ marginBottom: 30 }}
                            rules={[{ required: true, message: 'Please select at least one project type' }]}
                        >
                            <Form.Item noStyle name="projectType">
                                <DarkCheckboxGroup>
                                    <Checkbox value="Mobile">Mobile</Checkbox>
                                    <Checkbox value="Design">Design</Checkbox>
                                    <Checkbox value="Web">Web</Checkbox>
                                    <Checkbox value="Branding">Branding</Checkbox>
                                    <Checkbox value="Desktop">Desktop</Checkbox>
                                    <Checkbox value="Other">Other</Checkbox>
                                </DarkCheckboxGroup>
                            </Form.Item>
                        </Form.Item>


                    <Form.Item
                        label="Describe your project"
                        name="message"
                        rules={[{ required: true, message: 'Please describe your project' }]}
                        style={{ marginBottom: 25 }}
                    >
                        <DarkTextArea rows={5} />
                    </Form.Item>
                    <Form.Item>
                        <SubmitButton type="submit" disabled={isLoading}>
                            <svg viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.8152 14.0319c.3507-.0207.526-.196.526-.526L15.3104.5413c.0206-.3506-.1444-.5157-.495-.495L1.8506.0153c-.33 0-.5054.1754-.526.526V1.779c0 .33.1753.5054.526.526h9.592L.8914 12.856c-.2475.2476-.2475.4952 0 .7427l.8664.8663c.2475.2476.495.2476.7426 0l10.551-10.551v9.5919c.0207.1444.0826.2681.1857.3713s.2166.1547.3404.1547z" />
                            </svg>
                            Send Message {isLoading && <Spin size="small" style={{ marginLeft: 8 }} />}
                        </SubmitButton>
                    </Form.Item>
                </Form>
            </ContactForm>


        </PageWrapper>
    );
};

export default Contact;